import React from "react";
import { Outlet } from "react-router-dom";
import Content from "../../Components/Core/Content";
import { useTenantContent } from "../../Context/TenantContentContext";
import FeatureDisabled from "../../Components/Core/FeatureDisabled";
import Loader from "../../Components/Core/Loader";

const Blog = () => {
  const { content, loading } = useTenantContent();

  if (loading || !content) return <Loader />;

  if (content && content.isBlogPageEnabled === false) {
    return <FeatureDisabled featureName="صفحه مقالات و بلاگ" isSubscriptionExpired={content.isSubscriptionExpired} />;
  }

  return (
    <div>
      <Content>
        <Outlet />
      </Content>
    </div>
  );
};

export default Blog;
